import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useAtomValue } from 'jotai'
import { isAuthenticatedAtom } from '@/store/auth.atom'

export const Route = createFileRoute('/')({
  component: IndexFallback,
})

function IndexFallback() {
  const isAuthenticated = useAtomValue(isAuthenticatedAtom)
  useEffect(() => {
    if (isAuthenticated) {
      window.location.replace('/dashboards')
    } else {
      window.location.replace('/login')
    }
  }, [isAuthenticated])
  return (
    <div className="w-screen h-screen flex items-center justify-center text-[#CE7A58] font-semibold text-[20px]">
      Đang kiểm tra đăng nhập...
    </div>
  )
}
